module.exports = __webpack_public_path__ + "img/20241215_3.ebdd33e1.jpg";